// meta-frentista-ia-a4 — tradução gerada a partir de scripts/i18n/out/missing-es.json
const catalogo: Record<string, string> = {
    "A IA leu a semana da sua degustação de Meta de Frentista.": "La IA leyó la semana de su degustación del Objetivo del Playero.",
    "Faltam 10 dias. Veja os resultados até agora e peça para continuar.": "Faltan 10 días. Vea los resultados hasta ahora y pida continuar.",
    "Leitura da semana pronta": "Lectura de la semana lista",
    "Meta de Frentista pronta para sua equipe": "Objetivo del Playero listo para su equipo",
    "Montamos uma meta com os dados dos seus postos. Veja e ative com um clique.": "Armamos un objetivo con los datos de sus estaciones. Véalo y actívelo con un clic.",
    "Sua degustação está acabando": "Su degustación está terminando",
    "Sua degustação terminou": "Su degustación terminó",
    "Veja como ficou a equipe antes e durante a Meta de Frentista.": "Vea cómo quedó el equipo antes y durante el Objetivo del Playero.",
};

export default catalogo;
